import React from 'react';
import MiscellaneousServicesOutlined from '@mui/icons-material/MiscellaneousServicesOutlined';
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import StatCard from '../StatCard'

const CardObra = (props) => {
  const obrasPendentes = useSelector((state) => state.dashboard?.dashboard?.obrasPendentes)

  return (
    <StatCard
      {...props}
      label="Obras pendentes de aprovação"
      value={obrasPendentes ? obrasPendentes : 0}
      icon={<MiscellaneousServicesOutlined />}
    />
  );
}

CardObra.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
}

export default CardObra
